import { GraduationCap, Rocket, Store, Home, Briefcase, ShoppingCart, Video, TrendingUp, Compass } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";
import { PERSONAS } from "../../data/site";

const ICONS = [GraduationCap, Rocket, Store, Home, Briefcase, ShoppingCart, Video, TrendingUp, Compass];

export const Personas = () => (
  <section data-testid="personas-section" className="py-24 sm:py-28 bg-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHead
        overline="Who Should Join"
        title="Who Is This Program For?"
        sub="No advanced technical or coding knowledge is required."
      />
      <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {PERSONAS.map((p, i) => {
          const Icon = ICONS[i];
          return (
            <Reveal key={p.title} delay={(i % 3) * 0.06}>
              <div
                data-testid={`persona-${p.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="group h-full bg-background border border-slate-200/80 rounded-2xl p-6 hover:border-electric/40 hover:shadow-xl hover:shadow-electric/5 hover:-translate-y-1 transition-all duration-300"
              >
                <span className="w-11 h-11 rounded-xl bg-electric/10 flex items-center justify-center group-hover:bg-electric transition-colors">
                  <Icon size={18} className="text-electric group-hover:text-white transition-colors" />
                </span>
                <h3 className="mt-4 font-display font-semibold text-navy text-base">{p.title}</h3>
                <p className="mt-1.5 text-sm text-slate-500 leading-relaxed">{p.desc}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
